export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';

export function dismissNotification(notification) {
  return {
    type: DISMISS_NOTIFICATION,
    notification
  };
}
